import Tag from "@/models/tag/tag";
import { crudService, CrudServiceType } from "./crudService";
import { RestClient } from "./restClient";

export type TagServiceType = CrudServiceType<Tag>;

const tagServices = (client: RestClient, path: string): TagServiceType => ({
  ...crudService<Tag>(client, path),
});

export default tagServices;
